import { plainToInstance } from 'class-transformer'
import { TaskBase } from '@core/entities/task/TaskBase'
import { ILinkedTaskResult } from '@core/entities/linkedProcesses'

export class LinkedTaskResult extends TaskBase<ILinkedTaskResult> {
  questionId: string

  public static new(payload: unknown): LinkedTaskResult {
    const entity = plainToInstance(LinkedTaskResult, payload)

    return entity
  }
}
